module.exports = __webpack_public_path__ + "11ec006445b36d08a5a77692e56d1b96.svg";